<template>
  <v-container mt-1>
    <!-- <v-layout row v-if="error">
          <v-flex xs12 sm6 offset-sm3>
              <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
          </v-flex>
    </v-layout>-->
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignin">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="uid"
                      label="Email"
                      id="uid"
                      v-model="email"
                      type="uid"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="pwd"
                      label="Password"
                      id="pwd"
                      v-model="password"
                      type="password"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row v-show="showError">
                  <v-flex xs12>
                    <v-alert
                      :value="true"
                      color="error"
                      icon="warning"
                      outline
                    >
                      Login Failed. {{authenticationError}}
                    </v-alert>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 text-xs-center>
                    <v-btn type="submit" color="primary" large>
                      Sign in
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 text-xs-right mt-5>
                    <v-btn color="" small @click="onResetPassword">
                      I forgot my password
                    </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- {{userData}} -->
    <!-- {{authenticationError}} -->
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import router from "@/router";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      loginHasError: false,
    };
  },
  computed: {
    ...mapGetters("auth", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode",
      'userHasPublicRole',
      'userHasInternalRole',
      'userData'

    ]),
    showError () {
      return this.loginHasError && !this.password
    }
  },
  methods: {
    ...mapActions("auth", ["login"]),
    ...mapActions("adminUser", ["resetPassword"]),
    async onSignin() {
      // Perform a simple validation that email and password have been typed in
      if (this.email != "" && this.password != "") {
        const result = await this.login({ email: this.email, password: this.password });
        this.password = "";

        if (result && result.mfaRequired) {
          router.push(result.method === "totp" ? "/mfa-totp" : "/mfa-code");
          return;
        }

        this.loginHasError = !result || result.error;
        if (!this.loginHasError) {
          router.push("/");
        }
      }
    },
    async onResetPassword() {
      router.push("/reset-password");
    },
  }
};

</script>